// extracted by mini-css-extract-plugin
module.exports = {"gifContainer":"ImageWrapper_gifContainer__3rtW-","gifButton":"ImageWrapper_gifButton__1rkJB"};